import { useEffect, useState } from "react";
import HeaderTarifs from "./HeaderTarifs";
import RatePlanGrid from "./RatePlanGrid/RatePlanGrid";
import RatePlansDrawer from "./RatePlansDrawer";
import axios from "axios";
import { useParams } from "react-router-dom";
import { TbX } from "react-icons/tb";

const TarifsPage = ({ needRatePlanMsg, setNeedRatePlanMsg, setActivePage }) => {
  const { hotelId } = useParams();

  const [rooms, setRooms] = useState([]);
  const [ratePlans, setRatePlans] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [editingRatePlan, setEditingRatePlan] = useState(null);

  useEffect(() => {
    axios.get(`https://api.komorotel.com/api/rooms/hotel/${hotelId}`)
      .then((res) => setRooms(res.data))
      .catch(console.error);
  }, [hotelId]);

  useEffect(() => {
    axios.get(`https://api.komorotel.com/api/rateplans/hotel/${hotelId}`)
      .then((res) => setRatePlans(res.data))
      .catch(console.error);
  }, [hotelId]);

  const closeDrawer = () => {
    setShowDrawer(false);
    setEditingRatePlan(null);
  };

  const handleCreateRatePlan = async (payload) => {
    try {
      const res = await axios.post("https://api.komorotel.com/api/rateplans", payload, {
        withCredentials: true
      });
      setRatePlans((prev) => [...prev, res.data]);
      setActivePage("inventory");
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdateRatePlan = async (ratePlanId, payload) => {
    try {
      const res = await axios.put(
        `https://api.komorotel.com/api/rateplans/${ratePlanId}`,
        payload,
        { withCredentials: true }
      );
      setRatePlans((prev) =>
        prev.map((plan) => plan._id === ratePlanId ? res.data : plan)
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteRatePlan = async (plan) => {
    try {
      await axios.delete(`https://api.komorotel.com/api/rateplans/${plan._id}`, {
        withCredentials: true
      });
      setRatePlans((prev) => prev.filter((rp) => rp._id !== plan._id));
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (plan) => {
    setEditingRatePlan(plan);
    setShowDrawer(true);
  };

  return (
    <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col gap-8">

      {/* Banner */}
      {needRatePlanMsg && (
        <div className="flex items-start gap-3 px-4 py-3 bg-amber-50 border border-amber-200 rounded-xl">
          <span className="text-amber-500 text-lg shrink-0">⚡</span>
          <div className="flex-1">
            <p className="text-sm font-semibold text-amber-800">Disponibilité configurée !</p>
            <p className="text-xs text-amber-600 mt-0.5">
              Créez maintenant un tarif pour rendre votre chambre réservable.
            </p>
          </div>
          <button
            onClick={() => setNeedRatePlanMsg(false)}
            className="text-amber-400 hover:text-amber-600 transition"
          >
            <TbX className="text-base" />
          </button>
        </div>
      )}

      <HeaderTarifs openDrawer={() => setShowDrawer(true)} />

      <RatePlanGrid
        ratePlans={ratePlans}
        handleEdit={handleEdit}
        handleDelete={handleDeleteRatePlan}
      />

      <RatePlansDrawer
        show={showDrawer}
        onHide={closeDrawer}
        rooms={rooms}
        onCreate={handleCreateRatePlan}
        onUpdate={handleUpdateRatePlan}
        hotelId={hotelId}
        editingPlan={editingRatePlan}
      />
    </div>
  );
};

export default TarifsPage;